import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Icon } from '@atlas/ui';

const WarningTextField = ({ value }) => {
  const [domPurify, setDomPurify] = useState({});

  useEffect(() => {
    import('dompurify').then(DOMPurifyModule => {
      setDomPurify({ ...DOMPurifyModule.default });
    });
  }, []);

  if (!domPurify.sanitize) return null;

  return (
    <div className="warning-text-field">
      <Icon className="warning-text-field__icon" name="warning" />
      <div
        className="warning-text-field__text"
        dangerouslySetInnerHTML={{ __html: domPurify.sanitize(value) }}
      />
    </div>
  );
};

WarningTextField.propTypes = {
  value: PropTypes.string.isRequired,
};

export default WarningTextField;
